import { render, staticRenderFns } from "./ArrobaMedellinHorizontalCardAcademic.html?vue&type=template&id=180a7bba&scoped=true&"
import script from "./ArrobaMedellinHorizontalCardAcademic.vue?vue&type=script&lang=js&"
export * from "./ArrobaMedellinHorizontalCardAcademic.vue?vue&type=script&lang=js&"
import style0 from "./ArrobaMedellinHorizontalCardAcademic.scss?vue&type=style&index=0&id=180a7bba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180a7bba",
  null
  
)

export default component.exports